import { Component, EventEmitter, Input, Output } from '@angular/core';

// Shared page-size + total-count + <pagination-controls> bar, used wherever
// a list is paged via ngx-pagination's `pageable` convention
// ({currentPage, itemsPerPage, totalItems}). Presentational only — the
// parent owns the actual data fetch; this just emits size/page changes.
@Component({
  selector: 'app-pagination-bar',
  templateUrl: './pagination-bar.component.html',
})
export class PaginationBarComponent {
  @Input() pageable: { currentPage: number; itemsPerPage: number; totalItems: number };
  // e.g. "visitor" / "guest" / "user" — used for the "N <label>(s) total" text.
  @Input() itemLabel = 'item';
  // Only render the <select> + total text when there's more than one page
  // worth of data, matching the threshold already used on pages like
  // registrationCode.component.html.
  @Input() alwaysShowMeta = true;
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  readonly pageSizeOptions = [10, 20, 30, 40];

  onPageSizeChange(size: number): void {
    this.pageSizeChange.emit(+size);
  }

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  // Naively appending "s" breaks for a label like "report entry" (-> "report
  // entrys" instead of "report entries") — consonant+y takes "-ies", e.g.
  // "entry"/"city", while vowel+y just takes "-s", e.g. "key"/"day".
  pluralize(label: string): string {
    if (/[^aeiou]y$/i.test(label)) {
      return label.slice(0, -1) + 'ies';
    }
    return label + 's';
  }
}
